module.exports = __webpack_public_path__ + "static/img/gtim.bdef459d.png";